import React from 'react';
import 'rc-slider/assets/index.css';
import Slider from 'rc-slider';

/**
 * Daily Wet Slider component
 */
const DailyWetSlider = (props) => {
  return (
    <div className="nppe2-fc-daily-wet-slider nppe2-fc-slider">
      <div className="row">
        <div className="col-xs-6 nppe2-fc-slider__text" disabled={props.greyed}>
          {props.data.label}
        </div>
        <div className="col-xs-6 text-right nppe2-fc-slider__text--red" disabled={props.greyedWeeks}>
          {props.selectedLabel} {props.wetPackage}
        </div>
      </div>
      <Slider
        name="nppe2-fc-daily-wet-slider"
        value={props.selected}
        min={0}
        max={props.maxSelected}
        step={1}
        disabled={props.greyed}
        onChange={(value) => props.onSelect(value)}
      />
    </div>
  );

};

export default DailyWetSlider;
